export default {
  title: {
    en: 'Action Required: Update Address',
  },
  text: {
    en: `We were unable to deliver your shipment to the address provided. 
      Please update your shipping information as soon as possible in order to add limited time offer products 
      to your queue and don't miss out.`,
  },
}
